<h2 mat-dialog-title class="title">Create tenant</h2>

<div mat-dialog-content class="content">
  <mat-form-field appearance="outline" class="full">
    <mat-label>Tenant name</mat-label>
    <input matInput [formControl]="form.controls.name" placeholder="e.g., Acme Inc" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Plan</mat-label>
    <mat-select [formControl]="form.controls.plan_type">
      <mat-option value="free">Free</mat-option>
      <mat-option value="pro">Pro</mat-option>
      <mat-option value="enterprise">Enterprise</mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline" class="full">
    <mat-label>Host URL</mat-label>
    <input matInput [formControl]="form.controls.host_url" placeholder="https://someCompany.com" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full required">
    <mat-label>Initial admin name</mat-label>
    <input matInput [formControl]="form.controls.initial_admin_name" placeholder="john.smith" />
  </mat-form-field>

  <mat-form-field appearance="outline" class="full required">
    <mat-label>Initial admin email</mat-label>
    <input matInput [formControl]="form.controls.initial_admin_email" placeholder="admin@company.com" />
  </mat-form-field>
</div>

<div mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" (click)="submit()">Create</button>
</div>
